import React from "react"
import './DocumentsDatesBlock.scss'
import { Container, Row, Col } from "react-bootstrap";
import DocumentsBlockItem from "./DocumentsBlockItem";
import DatesTabsBlock from "./DatesTabsBlock";

function DocumentsDatesBlock({ targetDate }) {
    return (
        <div className="documents-block" id="documents">
            <Container>
                <h3>Документы</h3>
                <Row className="documents-list gy-3">
                    <Col xs={12} sm={12} xl={4}>
                        <DocumentsBlockItem num={'01'} title={"Положение \nоб олимпиаде"} href={`${window.location.origin}/docs/Положение об Олимпиаде Даля.pdf`}/>
                    </Col>
                    <Col xs={12} sm={12} xl={4}>
                        <DocumentsBlockItem num={'02'} title={'Регламент \nолимпиады'} href={`${window.location.origin}/docs/Регламент Олимпиады В.И. Даля.pdf`}/>
                    </Col>
                    <Col xs={12} sm={12} xl={4}>
                        <DocumentsBlockItem num={'03'} title={'Согласие на обработку персональных данных '} href={`${window.location.origin}/docs/СПД Олимпиада Даля.docx`} />
                    </Col>
                </Row>
            </Container>

            <DatesTabsBlock targetDate={targetDate }/>
        </div>
    );
}

export default DocumentsDatesBlock;
